// Geotab Keyless Domain Configuration
export const geotabkeylessConfig = {
  // Basic domain information
  id: 'geotab-keyless',
  name: 'Geotab Keyless',
  tagline: 'Geotab Keyless Solutions',
  description: 'Professional keyless entry solutions for fleet management.',
  
  // Assets
  logo: '/assets/logos/geotab-keyless-logo',
  whiteLogo: '/assets/logos/geotab-keyless-white-logo',
  favicon: '/assets/favicons/geotab-keyless-favicon.png',
  icon: '/assets/icons/geotab-keyless',
  
  // Navigation
  pages: ['home', 'solutions', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
    
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/keyless-system',

  // UI Configuration
  variant: 'clean',
  showFeatures: true,
  showTestimonials: true,
  
  // Content sections
  hero: {
    title: 'Geotab Keyless Solution',
    subtitle: 'Professional keyless entry solution for fleet management',
    features: ['Professional Grade', 'Fleet Integration', 'Secure Access']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab Keyless Solution Gallery',
    subtitle: 'Explore our professional keyless entry and access control solution',
    description: 'See how Geotab Keyless transforms fleet security with advanced access technology'
  },

  features: {
    title: 'Geotab Keyless Features',
    subtitle: 'Professional Keyless Entry Solutions',
    description: 'Advanced keyless entry technology designed specifically for fleet operations and management.',
    items: [
      {
        title: 'Professional Grade Security',
        description: 'Enterprise-level security features designed for professional fleet operations.',
        icon: '🔒'
      },
      {
        title: 'Fleet Integration',
        description: 'Seamless integration with existing fleet management systems and workflows.',
        icon: '🔗'
      },
      {
        title: 'Remote Management',
        description: 'Complete remote management capabilities for fleet administrators.',
        icon: '📱'
      },
      {
        title: 'Audit & Compliance',
        description: 'Comprehensive audit trails and compliance reporting for fleet operations.',
        icon: '📊'
      }
    ]
  },
  
  solutions: {
    title: 'Geotab Keyless Solution',
    subtitle: 'Professional keyless entry solution for fleet management',
    description: 'Keyless entry technology designed specifically for fleet operations and management.',
    sections: [
      {
        title: 'Reduce Cost and improve productivity',
        description: 'Eliminate the hassle and expense of managing physical keys with keyless entry systems. With Geotab Keyless, say goodbye to lost keys and hello to a more efficient fleet. Streamline your fleet operations with a secure, convenient, and cost-effective solution.'
      },
      {
        title: 'Boost Fleet Utilization',
        description: "Maximize the use of your vehicles and increase operational efficiency. Geotab Keyless provides 24/7 self-service access, allowing drivers to pick up and drop off vehicles anytime, anywhere. This increases fleet utilization and reduces idle time."
      },
      {
        title: 'Enhanced Security',
        description: 'Safeguard your vehicles with advanced security features. Geotab Keyless provides real-time alerts and monitoring, ensuring that only authorized drivers can access your vehicles. This reduces the risk of unauthorized use and protects your fleet from theft and vandalism.'
      },
      {
        title: 'Seamless Integrations',
        description: 'Integrate Geotab Keyless with your existing fleet management system for a seamless and efficient fleet experience. Geotab Keyless is compatible with Geotab, allowing you to manage your fleet with a single platform.'
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "I don't know how we'd do it without Geotab – the solution is literally in every aspect of our operations.",
      author: "Jonathan Hamilton",
      role: "Director of Fleet Safety and Compliance",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/25.jpg"
    },
    {
      content: "We're excited about what's coming next. It just keeps getting better and better, working with their technology and continuing to evolve. It's been great.",
      author: "Christian Reisch",
      role: "Co-owner",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/20.jpg"
    }
  ],

  blog: {
    title: 'Geotab Keyless Blog',
    subtitle: 'News and Insights',
    description: 'Stay informed with the latest news and insights in fleet management and industry best practices.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Geotab Keyless - Professional Keyless Entry Solutions',
    description: 'Geotab keyless entry solutions for fleets with advanced technology, secure access, and comprehensive fleet management.',
    keywords: [
      'Geotab keyless', 'keyless entry', 'fleet management', 'fleet security', 'professional keyless',
      'Geotab keyless entry', 'fleet keyless solutions', 'professional keyless systems', 'fleet access control', 'keyless technology',
      'fleet keyless management', 'keyless fleet security', 'professional keyless entry', 'fleet security systems',
      'keyless fleet solutions', 'Geotab keyless technology', 'fleet access management', 'keyless fleet systems'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab Keyless - Professional Keyless Entry Solutions',
    ogDescription: 'Professional keyless entry solutions for fleet management. Advanced technology, secure access, fleet integration.',
    ogType: 'website',
    ogUrl: 'https://geotabkeyless.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab Keyless - Professional Keyless Entry Solutions',
    twitterDescription: 'Professional keyless entry solutions for fleet management. Advanced technology, secure access, fleet integration.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Keyless',
    publisher: 'Geotab Keyless',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Geotab Keyless - Professional Keyless Entry Solutions',
        description: 'Professional Geotab keyless entry solutions for fleet management. Advanced technology, secure access, and fleet integration.',
        keywords: ['Geotab keyless', 'keyless entry', 'fleet management', 'fleet security', 'professional keyless']
      },
      solutions: {
        title: 'Geotab Keyless Solutions - Professional Keyless Services',
        description: 'Comprehensive keyless entry solutions and fleet security services. Professional keyless systems and fleet integration.',
        keywords: ['keyless entry solutions', 'fleet security services', 'keyless systems', 'fleet integration']
      },
      products: {
        title: 'Geotab Keyless - Access Control Technology & Equipment',
        description: 'Professional keyless entry products and technology equipment. Advanced keyless systems and fleet security solutions.',
        keywords: ['keyless entry products', 'keyless technology equipment', 'professional keyless systems', 'fleet security equipment']
      },
      blog: {
        title: 'Geotab Keyless News, Insights & Blog',
        description: 'Latest news, insights, and best practices for keyless entry and fleet security with professional tips and technology updates.',
        keywords: ['keyless entry news', 'fleet security insights', 'keyless technology tips', 'fleet security best practices']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
